<ng-container *ngIf="hyundaiIntegrationEnabled$ | async as integrationEnabled">
  <ng-container *ngIf="integrationEnabled == '1'">
    <ng-container class="flex flex-col"
      *ngIf="this?.serviceLaneFacade?.hyundaiDashboardData$ | async as hyundaiDashboardData; else dashboardLoading">
      <div *ngIf="hyundaiDashboardData?.error === null">
        <div class="w-full z-10 h-14 mt-6" fxLayoutAlign="space-between center">
          <h2>Vehicle Information</h2>
          <button mat-icon-button class="mr-1" (click)="toggleCollapse(vehicleInfoUi)">
            <mat-icon>{{ vehicleInfoUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
          </button>
        </div>
        <ng-container *ngIf="!vehicleInfoUi?.collapsed">
          <div class="mb-5 py-0 px-4 text-sm"
            *ngIf="isObject(hyundaiDashboardData?.dashboard?.vehicleData); else vehicleMessage">
            <div class="flex flex-row text-grey-600">
              <div class="w-1/2 flex ">
                <span>Vehicle Description</span>
              </div>
              <div class="w-1/2 flex">
                <span>Make/Model</span>
              </div>
            </div>

            <div class="flex flex-row pb-2">
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.VehicleYear }}
                  {{ hyundaiDashboardData?.dashboard?.vehicleData?.VehicleAlias }}</span>
              </div>
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.Brand === 'H' ? 'Hyundai' : 'Genesis' }}
                  {{ hyundaiDashboardData?.dashboard?.vehicleData?.Carline }}</span>
              </div>
            </div>

            <div class="flex flex-row text-grey-600">
              <div class="w-1/2 flex">
                <span>Trim</span>
              </div>
              <div class="w-1/2 flex">
                <span>Exterior & Interior Color</span>
              </div>
            </div>

            <div class="flex flex-row pb-2">
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.VehicleTrim }}</span>
              </div>
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.ExteriorColour }},
                  {{ hyundaiDashboardData?.dashboard?.vehicleData?.InteriorColour }}</span>
              </div>
            </div>


            <div class="flex flex-row text-grey-600">
              <div class="w-1/2 flex">
                <span>Transmission</span>
              </div>
              <div class="w-1/2 flex">
                <span>Engine/Emissions</span>
              </div>
            </div>

            <div class="flex flex-row pb-2">
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.Transmission }}</span>
              </div>
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.Engine }},
                  {{ hyundaiDashboardData?.dashboard?.vehicleData?.Fuel }}</span>
              </div>
            </div>

            <div class="flex flex-row text-grey-600">
              <div class="w-1/2 flex">
                <span>Purchase Date</span>
              </div>
              <div class="w-1/2 flex">
                <span>Warranty Start</span>
              </div>
            </div>

            <div class="flex flex-row pb-2">
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.PurchaseDate | date: 'mediumDate' }}</span>
              </div>
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.WarrantyStartDate | date: 'mediumDate' }}</span>
              </div>
            </div>

            <div class="flex flex-row text-grey-600">
              <div class="w-1/2 flex">
                <span>Retail Dealer</span>
              </div>
            </div>

            <div class="flex flex-row pb-2">
              <div class="w-1/2 flex">
                <span>{{ hyundaiDashboardData?.dashboard?.vehicleData?.RetailDealer }}</span>
              </div>
            </div>

          </div>
          <ng-template #vehicleMessage>
            <span
              class="flex font-medium text-grey-600 text-lg pb-3 px-4">{{hyundaiDashboardData?.dashboard?.vehicleData}}</span>
          </ng-template>
        </ng-container>

        <div class="w-full z-10 h-14" fxLayoutAlign="space-between center">
          <h2 [ngStyle]="{ color: openRecallsOrCampaignsOrErrorsExist ? 'red' : '#000' }">Recall/Service Campaigns</h2>
          <button mat-icon-button class="mr-1" (click)="toggleCollapse(recallsUi)">
            <mat-icon>{{ recallsUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
          </button>
        </div>
        <ng-container *ngIf="!recallsUi?.collapsed">

          <div class="mb-5 py-0 px-4">
            <div *ngIf="hyundaiDashboardData?.dashboard?.recallCampaigns?.length > 0">
              <div class="flex flex-col border border-grey-300 rounded-xl p-4 mb-4"
                *ngFor="let campaign of hyundaiDashboardData?.dashboard?.recallCampaigns | filterBy: ['RepairStatus']:false">
                <div class="flex flex-row place-content-between">
                  <span class="font-medium text-lg pb-1">Recall</span>
                  <span *ngIf="campaign?.RepairStatus; else open"
                    class="font-medium text-lg pb-1 text-green-600">CLOSED</span>
                  <ng-template class="flex flex-row" #open>
                    <span class="text-red-600 font-medium text-lg pb-1">OPEN</span>
                  </ng-template>
                </div>

                <span class="text-lg">{{ campaign?.CampaignId + ': ' + campaign?.HACCName }}</span>
                <span class="text-base pb-2" *ngIf="campaign?.RepairStatus">Repaired on {{ campaign.RepairDate |
                  date: 'mediumDate' }}</span>
                <div class="flex flex-row text-grey-600 pl-4">
                  <span class="text-sm w-4/12 flex">Recall Id</span>
                  <span class="text-sm w-4/12 flex">Recall Alias</span>
                  <span class="text-sm w-4/12 flex">Transport Canada Id</span>
                </div>
                <div class="flex flex-row pb-2 pl-4">
                  <span class="text-sm w-4/12 flex">{{ campaign?.HACCRecallId }}</span>
                  <span class="text-sm w-4/12 flex">{{
                    campaign?.HACCRecallAlias
                    }}</span>
                  <span class="text-sm w-4/12 flex">{{
                    campaign?.TransportCanadaId
                    }}</span>
                </div>
                <span class="text-grey-600">{{ campaign?.HACCDescription }}</span>

                <span class="font-medium text-base underline pt-2 pb-0"> Recall Campaign/Parts Information </span>
                <div
                  *ngIf="(hyundaiDashboardData?.dashboard?.recallCampaignParts | getCampaignOperation: campaign?.CampaignId).length>0; else noOpenRecallCampaignInfo">
                  <div class="text-blue-500 cursor-pointer py-2" value="false" #recallCampaignPartsToggle
                    (click)="recallCampaignPartsToggle.value = !recallCampaignPartsToggle.value">
                    <span class="text-blue-500 cursor-pointer pt-1">{{recallCampaignPartsToggle.value ? 'Hide Details' :
                      'Show Details'}}</span>
                  </div>
                  <div *ngIf="recallCampaignPartsToggle.value && hyundaiDashboardData?.dashboard?.recallCampaignParts"
                    class="my-1.5" fxLayout="column">
                    <div class="campaign-operation-container pb-4"
                      *ngFor="let campaignOp of hyundaiDashboardData?.dashboard?.recallCampaignParts | getCampaignOperation: campaign?.CampaignId as recallCampaignParts; let i = index;">
                      <div class="flex flex-row text-grey-600 pl-4">
                        <span class="text-sm w-4/12 flex">Campaign Operation</span>
                        <span class="text-sm w-4/12 flex">Labour time</span>
                        <span class="text-sm w-4/12 flex"></span>
                      </div>

                      <div class="flex flex-row pb-2 pl-4">
                        <span class="text-sm w-4/12 flex">{{campaignOp.CampaignOperationId}}</span>
                        <span class="text-sm w-4/12 flex">{{campaignOp.LabourTime}}</span>
                        <span class="text-sm w-4/12 flex"></span>
                      </div>

                      <div class="flex flex-column text-grey-600 pl-4">
                        <span class="text-sm w-4/12 flex">List of Parts: </span>
                      </div>

                      <div *ngIf="campaignOp.Parts.length>0; else noOpenRecallPartsList">
                        <div class="flex flex-row pb-2 pl-4" *ngFor="let part of campaignOp.Parts">
                          <span class="primary-bullet">· </span>
                          <span>{{part.PartId}} - {{part.Description}} </span>
                        </div>
                      </div>

                      <ng-template #noOpenRecallPartsList>
                        <div class="flex flex-row pb-2 pl-4">
                          <span>No parts found for this campaign operation.</span>
                        </div>
                      </ng-template>
                      <mat-divider *ngIf="i < recallCampaignParts.length - 1"></mat-divider>
                    </div>
                  </div>
                </div>

                <ng-template #noOpenRecallCampaignInfo>
                  <div class="flex flex-row pb-2 pl-4">
                    <span>No additional Recall Campaign/Parts information is available.</span>
                  </div>
                </ng-template>

                <span *ngFor="let document of campaign.Documents" class="text-blue-500 cursor-pointer pt-2"
                  (click)="downloadRecallDocument(document)">{{ document.FileAlias }}</span>
              </div>
            </div>

            <div *ngIf="hyundaiDashboardData?.dashboard?.serviceCampaigns?.length > 0">
              <div class="flex flex-col border border-grey-300 rounded-xl p-4 mb-4"
                *ngFor="let campaign of hyundaiDashboardData?.dashboard?.serviceCampaigns | filterBy: ['RepairStatus']:false">
                <div class="flex flex-row place-content-between">
                  <span class="font-medium text-lg pb-1">Service Campaign</span>
                  <span *ngIf="campaign?.RepairStatus; else open"
                    class="font-medium text-lg pb-1 text-green-600">CLOSED</span>
                  <ng-template class="flex flex-row" #open>
                    <span class="text-red-600 font-medium text-lg pb-1">OPEN</span>
                  </ng-template>
                </div>

                <span class="text-lg ">{{ campaign?.CampaignId + ': ' + campaign?.HACCName }}</span>

                <span class="text-base pb-2" *ngIf="campaign?.RepairStatus">Repaired on {{ campaign.RepairDate |
                  date: 'mediumDate' }}</span>

                <div class="flex flex-row place-content-between">
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">Start Date</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">End Date</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">Campaign Alias</span>
                </div>
                <div class="flex flex-row place-content-between pb-2">
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign.StartDate | date: 'mediumDate'
                    }}</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign.EndDate | date: 'mediumDate'
                    }}</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign?.HACCServiceCampaignAlias
                    }}</span>
                </div>

                <span class="text-grey-600">{{ campaign?.HACCDescription }}</span>
              </div>
            </div>

            <div *ngIf="hyundaiDashboardData?.dashboard?.recallCampaigns.length > 0">
              <div class="flex flex-col border border-grey-300 rounded-xl p-4 mb-4"
                *ngFor="let campaign of hyundaiDashboardData?.dashboard?.recallCampaigns | filterBy: ['RepairStatus']:true">
                <div class="flex flex-row place-content-between">
                  <span class="font-medium text-lg pb-1">Recall</span>
                  <span *ngIf="campaign?.RepairStatus; else open"
                    class="font-medium text-lg pb-1 text-green-600">CLOSED</span>
                  <ng-template class="flex flex-row" #open>
                    <span class="text-red-600 font-medium text-lg pb-1">OPEN</span>
                  </ng-template>
                </div>

                <span class="text-lg">{{ campaign?.CampaignId + ': ' + campaign?.HACCName }}</span>
                <span class="text-base pb-2" *ngIf="campaign?.RepairStatus">Repaired on {{ campaign.RepairDate |
                  date: 'mediumDate' }}</span>
                <div class="flex flex-row text-grey-600 pl-4">
                  <span class="text-sm w-4/12 flex">Recall Id</span>
                  <span class="text-sm w-4/12 flex">Recall Alias</span>
                  <span class="text-sm w-4/12 flex">Transport Canada Id</span>
                </div>
                <div class="flex flex-row pb-2 pl-4">
                  <span class="text-sm w-4/12 flex">{{ campaign?.HACCRecallId }}</span>
                  <span class="text-sm w-4/12 flex">{{
                    campaign?.HACCRecallAlias
                    }}</span>
                  <span class="text-sm w-4/12 flex">{{
                    campaign?.TransportCanadaId
                    }}</span>
                </div>
                <span class="text-grey-600">{{ campaign?.HACCDescription }}</span>

                <span class="font-medium text-base underline pt-2 pb-0"> Recall Campaign/Parts Information </span>
                <div
                  *ngIf="(hyundaiDashboardData?.dashboard?.recallCampaignParts | getCampaignOperation: campaign?.CampaignId).length>0; else noClosedRecallCampaignInfo">
                  <div class="text-blue-500 cursor-pointer py-2" value="false" #recallCampaignPartsToggle
                    (click)="recallCampaignPartsToggle.value = !recallCampaignPartsToggle.value">
                    <span class="text-blue-500 cursor-pointer pt-1">{{
                      recallCampaignPartsToggle.value ? 'Hide Details' : 'Show Details'
                      }}</span>
                  </div>
                  <div *ngIf="recallCampaignPartsToggle.value && hyundaiDashboardData?.dashboard?.recallCampaignParts"
                    class="my-1.5" fxLayout="column">
                    <div class="campaign-operation-container pb-4"
                      *ngFor="let campaignOp of hyundaiDashboardData?.dashboard?.recallCampaignParts | getCampaignOperation: campaign?.CampaignId as recallCampaignParts; let i = index;">
                      <div class="flex flex-row text-grey-600 pl-4">
                        <span class="text-sm w-4/12 flex">Campaign Operation</span>
                        <span class="text-sm w-4/12 flex">Labour time</span>
                        <span class="text-sm w-4/12 flex"></span>
                      </div>

                      <div class="flex flex-row pb-2 pl-4">
                        <span class="text-sm w-4/12 flex">{{campaignOp.CampaignOperationId}}</span>
                        <span class="text-sm w-4/12 flex">{{campaignOp.LabourTime}}</span>
                        <span class="text-sm w-4/12 flex"></span>
                      </div>

                      <div class="flex flex-column text-grey-600 pl-4">
                        <span class="text-sm w-4/12 flex">List of Parts: </span>
                      </div>

                      <div *ngIf="campaignOp.Parts.length>0; else noClosedRecallPartsList">
                        <div class="flex flex-row pb-2 pl-4" *ngFor="let part of campaignOp.Parts">
                          <span class="primary-bullet">· </span>
                          <span>{{part.PartId}} - {{part.Description}} </span>
                        </div>
                      </div>

                      <ng-template #noClosedRecallPartsList>
                        <div class="flex flex-row pb-2 pl-4">
                          <span>No parts found for this campaign operation.</span>
                        </div>
                      </ng-template>
                      <mat-divider *ngIf="i < recallCampaignParts.length - 1"></mat-divider>
                    </div>
                  </div>
                </div>

                <ng-template #noClosedRecallCampaignInfo>
                  <div class="flex flex-row pb-2 pl-4">
                    <span>No additional Recall Campaign/Parts information is available.</span>
                  </div>
                </ng-template>

                <span *ngFor="let document of campaign.Documents" class="text-blue-500 cursor-pointer pt-2"
                  (click)="downloadRecallDocument(document)">{{ document.FileAlias }}</span>
              </div>
            </div>

            <div *ngIf="hyundaiDashboardData?.dashboard?.serviceCampaigns">
              <div class="flex flex-col border border-grey-300 rounded-xl p-4 mb-4"
                *ngFor="let campaign of hyundaiDashboardData?.dashboard?.serviceCampaigns | filterBy: ['RepairStatus']:true">
                <div class="flex flex-row place-content-between">
                  <span class="font-medium text-lg pb-1">Service Campaign</span>
                  <span *ngIf="campaign?.RepairStatus; else open"
                    class="font-medium text-lg pb-1 text-green-600">CLOSED</span>
                  <ng-template class="flex flex-row" #open>
                    <span class="text-red-600 font-medium text-lg pb-1">OPEN</span>
                  </ng-template>
                </div>

                <span class="text-lg">{{ campaign?.CampaignId + ': ' + campaign?.HACCName }}</span>
                <span class="text-base pb-2" *ngIf="campaign?.RepairStatus">Repaired on {{ campaign.RepairDate |
                  date: 'mediumDate' }}</span>
                <div class="flex flex-row place-content-between">
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">Start Date</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">End Date</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center underline">Campaign Alias</span>
                </div>
                <div class="flex flex-row place-content-between pb-2">
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign.StartDate | date: 'mediumDate'
                    }}</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign.EndDate | date: 'mediumDate'
                    }}</span>
                  <span class="text-grey-600 text-sm w-4/12 flex place-content-center">{{
                    campaign?.HACCServiceCampaignAlias
                    }}</span>
                </div>
                <span class="text-grey-600">{{ campaign?.HACCDescription }}</span>
              </div>
            </div>

            <div *ngIf="
            (hyundaiDashboardData?.dashboard?.recallCampaignError && hyundaiDashboardData?.dashboard?.recallCampaignError?.Message.toLowerCase().includes('invalid hyundai vehicle vin')) ||
            (hyundaiDashboardData?.dashboard?.serviceCampaignError && hyundaiDashboardData?.dashboard?.serviceCampaignError?.Message.toLowerCase().includes('invalid hyundai vehicle vin'))
          " class="mb-3">
              <span class="text-red-600">The VIN entered is not a recognized vehicle. Lookup is only available for
                Hyundai
                or Genesis vehicles sold
                in Canada. This vehicle may have been sold in the USA. Please check the following link:
                <a href="https://autoservice.hyundaiusa.com/campaignhome" target="_blank">Hyundai USA VIN Lookup</a>
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-center">
            <span class="text-sm text-grey-500">Recall results were last updated on
              {{hyundaiDashboardData?.dashboard?.recallLastRefreshed}}</span>
          </div>
        </ng-container>

        <div class="w-full z-10 h-14" fxLayoutAlign="space-between center">
          <h2>Warranty Information</h2>
          <button mat-icon-button class="mr-1" (click)="toggleCollapse(warrantyUi)">
            <mat-icon>{{ warrantyUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
          </button>
        </div>
        <ng-container *ngIf="!warrantyUi?.collapsed">
          <div class="mb-5 py-0 px-4"
            *ngIf="isArray(hyundaiDashboardData?.dashboard?.warrantyData); else warrantyMessage">
            <div *ngIf="hyundaiDashboardData?.dashboard?.warrantyData">
              <div *ngFor="let warranty of hyundaiDashboardData?.dashboard?.warrantyData; let i = index"
                class="border border-grey-300 rounded-xl p-4 mb-4">
                <div class="flex flex-row">
                  <span class="font-medium text-lg">{{ warranty?.Name }} Warranty</span>
                </div>
                <div class="pl-4">
                  <div class="w-1/2">
                    <span class="pr-1">Warranty Term:</span>
                    <span>{{ warranty?.Months }} months</span>
                  </div>
                  <div class="w-1/2">
                    <span class="pr-1">Warranty Mileage:</span>
                    <span *ngIf="warranty?.Odometer > 0; else warrantyOdometerNA">{{
                      warranty?.Odometer | number | unitOfMeasure | async
                      }}</span>
                    <ng-template #warrantyOdometerNA>
                      <span>N/A</span>
                    </ng-template>
                  </div>

                  <div class="flex flex-row py-4 cursor-pointer" value="false" #warrantyDetailsToggle
                    (click)="warrantyDetailsToggle.value = !warrantyDetailsToggle.value">
                    <span class="text-xs text-blue-500">{{
                      warrantyDetailsToggle.value ? 'Hide Details' : 'Show Details'
                      }}</span>
                  </div>
                  <div *ngIf="warrantyDetailsToggle.value" class="flex flex-col p-3">
                    <span [innerHtml]="warranty?.Description" class="text-grey-600"></span>
                  </div>
                </div>
                <div *ngIf="warranty?.ChildWarrantyDetails">
                  <div class="w-1/2 mb-4">
                    <span class="font-medium text-base underline">Covered Components</span>
                  </div>

                  <div *ngFor="let childWarranty of warranty.ChildWarrantyDetails; let i = index" class="mb-4">
                    <div class="flex flex-row place-content-between">
                      <div class="flex flex-row pt-1.5">
                        <span class="pl-2 pr-1 text-base w-auto">{{ childWarranty.Name }}</span>
                        <span class="flex text-base">
                          - {{ childWarranty?.Months }} months /
                          {{ childWarranty?.Odometer | number | unitOfMeasure | async }}</span>
                      </div>

                      <span type="button" #childWarrantyDetailsToggle
                        (click)="childWarrantyDetailsToggle.value = !childWarrantyDetailsToggle.value"
                        class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg *ngIf="!childWarrantyDetailsToggle.value; else minus"
                          class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd" />
                        </svg>
                        <ng-template #minus>
                          <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                              clip-rule="evenodd" />
                          </svg>
                        </ng-template>
                        <span>Details</span>
                      </span>
                      <!-- <div value="false" class="flex flex-row border border-grey-500 rounded-xl cursor-pointer"
                    #childWarrantyDetailsToggle
                    (click)="childWarrantyDetailsToggle.value = !childWarrantyDetailsToggle.value">
                    <mat-icon class="text-base text-blue-500 pl-1.5">{{ childWarrantyDetailsToggle.value ? 'remove' :
                      'add' }}
                    </mat-icon>
                    <span class="mt-0.5 text-blue-500 pr-1">Details</span>
                  </div> -->
                    </div>
                    <div *ngIf="childWarrantyDetailsToggle.value" class="flex flex-col py-3 px-7 my-2 text-grey-600">
                      <span [innerHtml]="childWarranty?.Description"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #warrantyMessage>
            <span
              class="flex font-medium text-grey-600 text-lg pb-3 px-4">{{hyundaiDashboardData?.dashboard?.warrantyData}}</span>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #dashboardLoading>
      <ng-container class="flex flex-col"
        *ngIf="!(serviceLaneFacade.noHyundaiDashboardData$ | async); else noHyundaiDashboardData">
        <div class="w-full z-10 h-14">
          <h2>Vehicle Information</h2>
        </div>
        <div class="alerts-container py-0 px-4" id="alertsContainer">
          <div class="alert-block flex flex-col">
            <div class="flex flex-row mb-1" fxLayoutAlign="start center">
              <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
              <span class="animated-background h-4 w-1/3 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
            <div fxLayoutAlign="start start" class="pl-8">
              <span class="animated-background h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
          </div>
        </div>

        <div class="w-full z-10 h-14">
          <h2>Recall/Service Campaigns</h2>
        </div>
        <div class="alerts-container py-0 px-4" id="alertsContainer">
          <div class="alert-block flex flex-col">
            <div class="flex flex-row mb-1" fxLayoutAlign="start center">
              <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
              <span class="animated-background h-4 w-1/3 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
            <div fxLayoutAlign="start start" class="pl-8">
              <span class="animated-background h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
          </div>
        </div>

        <div class="w-full z-10 h-14">
          <h2>Warranty Information</h2>
        </div>
        <div class="alerts-container py-0 px-4" id="alertsContainer">
          <div class="alert-block flex flex-col">
            <div class="flex flex-row mb-1" fxLayoutAlign="start center">
              <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
              <span class="animated-background h-4 w-1/3 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
            <div fxLayoutAlign="start start" class="pl-8">
              <span class="animated-background h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded"></span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noHyundaiDashboardData>
        <ng-container class="flex flex-col">
          <div class="w-full z-10 h-14">
            <h2>Vehicle Information</h2>
          </div>
          <div class="alerts-container py-0 px-4" id="alertsContainer">
            <div fxLayoutAlign="start start">
              <span class="h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded">N/A</span>
            </div>
          </div>

          <div class="w-full z-10 h-14">
            <h2>Recall/Service Campaigns</h2>
          </div>
          <div class="alerts-container py-0 px-4" id="alertsContainer">
            <div fxLayoutAlign="start start">
              <span class="h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded">N/A</span>
            </div>
          </div>

          <div class="w-full z-10 h-14">
            <h2>Warranty Information</h2>
          </div>
          <div class="alerts-container py-0 px-4" id="alertsContainer">
            <div fxLayoutAlign="start start">
              <span class="h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded">N/A</span>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-template>

  </ng-container>

</ng-container>